<div id="shift-turnover-container">
  <app-progress-spinner [enabled]="init === false" />
  <p-blockUI [blocked]="loading === true" />
  <div
    id="contact-action-buttons"
    [style.display]="init === false ? 'none' : ''"
  >
    <div class="dates" id="daily-log-action-bar">
      <div class="no-padding-top-bottom date-section">
        <span class="label time-and-arrows cursor">
          <i class="fa fa-fw fa-arrow-left" (click)="previousDay()"></i>
        </span>
        <span class="label time-and-arrows"
          >{{ 'CRM.LABEL.START_DATE' | translate }}:</span
        >
        <span>
          <p-datepicker
            [(ngModel)]="startDate"
            (onSelect)="dateUpdate()"
            [autofocus]="false"
          />
        </span>
        <span class="label time-and-arrows">6:00 AM</span>
      </div>

      <div class="today-btn">
        <button
          pButton
          label="{{ 'CRM.LABEL.BUTTONS.GO_TO_TODAY' | translate }}"
          icon="fa fa-fw fa-calendar"
          (click)="goToToday()"
        ></button>
      </div>

      <div class="no-padding-top-bottom date-section">
        <span class="label time-and-arrows"
          >{{ 'CRM.LABEL.END_DATE' | translate }}:</span
        >
        <span>
          <p-datepicker [(ngModel)]="endDate" (onSelect)="dateUpdate(true)" />
        </span>
        <span class="label time-and-arrows">5:59 AM</span>
        <span class="label time-and-arrows cursor">
          <i class="fa fa-fw fa-arrow-right" (click)="nextDay()"></i>
        </span>
      </div>

      <div class="button-wrapper ui-input-group">
        <app-business-unit-filter
          (selectedBusinessUnitsChanged)="handleBusinessUnitChange()"
          #buFilter
        />
        <button
          pButton
          label="{{ 'CRM.LABEL.BUTTONS.NEW_SHIFT_CHANGE' | translate }}"
          icon="fa fa-fw fa-plus-square"
          (click)="newShiftChange()"
        ></button>
        <button
          pButton
          class="width-eighty"
          label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
          icon="fa fa-fw fa-eraser"
          (click)="clearScreen()"
        ></button>
        <button
          pButton
          class="refresh-button width-twenty"
          icon="fa fa-fw fa-refresh"
          (click)="refresh()"
        ></button>
      </div>
    </div>
  </div>

  <div [style.display]="init === false ? 'none' : ''">
    <app-general-grid
      [values]="elements"
      [columns]="columns"
      [loading]="loading"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [filterable]="true"
      [screenName]="screenName"
      [lazy]="true"
      (lazyLoad)="lazyLoad($event)"
      [includeExportCSV]="false"
      (changeViewEvent)="changeViewEvent($event)"
      scrollHeight="calc(100vh - 256px)"
      [usePaginator]="true"
      [rowsPerPageOptions]="[10, 20, 50]"
      [alwaysShowPaginator]="true"
      #grid
    />
  </div>
</div>
